import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import {
  // UncontrolledTooltip,
  Collapse,
  Nav,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
} from 'reactstrap';
import { MdKeyboardArrowDown, MdDashboard } from 'react-icons/md';
import { FaShoppingCart, FaHistory, FaShoppingBasket, FaTachometerAlt } from "react-icons/fa";
import { RiCheckboxBlankCircleLine } from "react-icons/ri";
import CustomerNav from '../../../configs/CustomerNav';

import sidebarBgImage from '../../../assets/img/sidebar/sidebar-4.jpg';
import bn from '../../../utils/bemnames';
const bem = bn.create('sidebar');
const sidebarBackground = {
  backgroundImage: `url("${sidebarBgImage}")`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};

class CustomerSiderBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenProduct: false,
            isOpenPages: true,
            isOpenLog: false,
            isOpenConfigSystem: false,
            isOpenService: false,
            isOpenOrder: false,
            isOpenPayment: false,
        }
    }

    handleClick = name => () => {
        this.setState(prevState => {
          const isOpen = prevState[`isOpen${name}`];
    
          return {
            [`isOpen${name}`]: !isOpen,
          };
        });
    };

    loadProductMenu = () => {
        // console.log(this.props.menuProduct.proxy);
        if ( Object.keys(this.props.menuProduct).length ) {
            return (
                <>
                    <NavItem
                        className={bem.e('nav-item')}
                        onClick={this.handleClick( 'Product' )}
                    >
                        <BSNavLink className={bem.e('nav-item-collapse')}>
                            <div className="d-flex">
                                <FaShoppingBasket className={bem.e('nav-item-icon')} />
                                <span className="nav-title align-self-start">Đăng ký dịch vụ</span>
                            </div>
                            <MdKeyboardArrowDown
                                className={bem.e('nav-item-icon')}
                                style={{
                                    padding: 0,
                                    transform: this.state.isOpenProduct
                                    ? 'rotate(0deg)'
                                    : 'rotate(-90deg)',
                                    transitionDuration: '0.3s',
                                    transitionProperty: 'transform',
                                }}
                            />
                        </BSNavLink>
                    </NavItem>
                    <Collapse isOpen={this.state.isOpenProduct} className="collapse-group">
                        {
                            this.props.vps && this.props.menuCustomer.vps ? (
                                <NavItem className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={this.props.menuProduct.vps.name}
                                        className=""
                                        tag={NavLink}
                                        to={this.props.menuProduct.vps.link}
                                        activeclassname=""
                                        exact={"false"}
                                    >
                                        <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')} />
                                        <span className="">{this.props.menuProduct.vps.title}</span>
                                    </BSNavLink>
                                </NavItem>
                            ) : (
                                <></>
                            )
                        }
                        {
                            this.props.vps_us && this.props.menuCustomer.vps_us ? (
                                <NavItem className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={this.props.menuProduct.vps_us.name}
                                        className=""
                                        tag={NavLink}
                                        to={this.props.menuProduct.vps_us.link}
                                        activeclassname=""
                                        exact={"false"}
                                    >
                                        <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')} />
                                        <span className="">{this.props.menuProduct.vps_us.title}</span>
                                    </BSNavLink>
                                </NavItem>
                            ) : (
                                <></>
                            )
                        }
                        {
                            this.props.cloudServer && this.props.menuCustomer.cloud_server ? (
                                <NavItem className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={this.props.menuProduct.cloudServer.name}
                                        className=""
                                        tag={NavLink}
                                        to={this.props.menuProduct.cloudServer.link}
                                        activeclassname=""
                                        exact={"false"}
                                    >
                                        <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')} />
                                        <span className="">{this.props.menuProduct.cloudServer.title}</span>
                                    </BSNavLink>
                                </NavItem>
                            ) : (
                                <></>
                            )
                        }
                        {
                            this.props.proxy && this.props.menuCustomer.proxy ? (
                                <NavItem className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={this.props.menuProduct.proxy.name}
                                        className=""
                                        tag={NavLink}
                                        to={this.props.menuProduct.proxy.link}
                                        activeclassname=""
                                        exact={"false"}
                                    >
                                        <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')} />
                                        <span className="">{this.props.menuProduct.proxy.title}</span>
                                    </BSNavLink>
                                </NavItem>
                            ) : (
                                <></>
                            )
                        }
                        {
                            this.props.hosting && this.props.menuCustomer.hosting_cpanel ? (
                                <NavItem className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={this.props.menuProduct.hosting.name}
                                        className=""
                                        tag={NavLink}
                                        to={this.props.menuProduct.hosting.link}
                                        activeclassname=""
                                        exact={"false"}
                                    >
                                        <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')} />
                                        <span className="">{this.props.menuProduct.hosting.title}</span>
                                    </BSNavLink>
                                </NavItem>
                            ) : (
                                <></>
                            )
                        }
                    </Collapse>
                </>
            )
        }
    }

    loadServiceMenu = () => {
        return (
            <>
                <NavItem
                    className={bem.e('nav-item')}
                    onClick={this.handleClick( 'Service' )}
                >
                    <BSNavLink className={bem.e('nav-item-collapse')}>
                        <div className="d-flex">
                            <FaTachometerAlt className={bem.e('nav-item-icon')} />
                            <span className="nav-title align-self-start">Quản lý dịch vụ</span>
                        </div>
                        <MdKeyboardArrowDown
                            className={bem.e('nav-item-icon')}
                            style={{
                                padding: 0,
                                transform: this.state.isOpenService
                                ? 'rotate(0deg)'
                                : 'rotate(-90deg)',
                                transitionDuration: '0.3s',
                                transitionProperty: 'transform',
                            }}
                        />
                    </BSNavLink>
                </NavItem>
                <Collapse isOpen={this.state.isOpenService} className="collapse-group">
                    {
                        this.props.vps ? (
                            <NavItem className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={"service_vps"}
                                    className=""
                                    tag={NavLink}
                                    to={"/dich-vu-vps/dang-su-dung.html"}
                                    activeclassname=""
                                    exact={"false"}
                                >
                                    <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')} />
                                    <span className="">Cloud VPS VN</span>
                                </BSNavLink>
                            </NavItem>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.vps_us ? (
                            <NavItem className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={"service_vps_us"}
                                    className=""
                                    tag={NavLink}
                                    to={"/dich-vu-vps-nn/dang-su-dung.html"}
                                    activeclassname=""
                                    exact={"false"}
                                >
                                    <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')} />
                                    <span className="">Cloud VPS NN</span>
                                </BSNavLink>
                            </NavItem>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.cloudServer ? (
                            <NavItem className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={"service_cloud_server"}
                                    className=""
                                    tag={NavLink}
                                    to={"/dich-vu-vps/dang-su-dung.html"}
                                    activeclassname=""
                                    exact={"false"}
                                >
                                    <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')} />
                                    <span className="">Cloud Server</span>
                                </BSNavLink>
                            </NavItem>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.proxy ? (
                            <NavItem className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={"service_proxy"}
                                    className=""
                                    tag={NavLink}
                                    to={"/dich-vu-proxy/dang-su-dung.html"}
                                    activeclassname=""
                                    exact={"false"}
                                >
                                    <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')} />
                                    <span className="">Proxy</span>
                                </BSNavLink>
                            </NavItem>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.hosting ? (
                            <NavItem className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={"service_hosting"}
                                    className=""
                                    tag={NavLink}
                                    to={"/dich-vu-hosting/dang-su-dung.html"}
                                    activeclassname=""
                                    exact={"false"}
                                >
                                    <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')} />
                                    <span className="">Cloud Hosting</span>
                                </BSNavLink>
                            </NavItem>
                        ) : (
                            <></>
                        )
                    }
                </Collapse>
            </>
        );
    }

    loadOrderMenu = () => {
        let menuOrder = [];
        menuOrder.push(
            <div key={'order'}>
                <NavItem
                    className={bem.e('nav-item')}
                    onClick={this.handleClick('Order')}
                >
                        <BSNavLink className={bem.e('nav-item-collapse')}>
                            <div className="d-flex">
                                <FaShoppingCart className={bem.e('nav-item-icon')} />
                                <span className="nav-title align-self-start">Quản lý đơn đặt hàng</span>
                            </div>
                            <MdKeyboardArrowDown
                                className={bem.e('nav-item-icon')}
                                style={{
                                    padding: 0,
                                    transform: this.state.isOpenOrder
                                    ? 'rotate(0deg)'
                                    : 'rotate(-90deg)',
                                    transitionDuration: '0.3s',
                                    transitionProperty: 'transform',
                                }}
                            />
                        </BSNavLink>
                </NavItem>
                <Collapse isOpen={this.state.isOpenOrder} className="collapse-group">
                    {
                        CustomerNav.order.map( ({ to, name, title, exact, Icon }, index) => (
                            <NavItem key={`order-${index}`} className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={name}
                                    className=""
                                    tag={NavLink}
                                    to={to}
                                    activeclassname=""
                                    exact={exact}
                                >
                                    <Icon className={bem.e('nav-item-icon')} />
                                    <span className="">{title}</span>
                                </BSNavLink>
                            </NavItem>
                        ))
                    }
                </Collapse>
            </div>
        )
        return (
            menuOrder
        );
    }

    loadOrderPayment = () => {
        let menuPayment = [];
        menuPayment.push(
            <>
                {
                    CustomerNav.payment.map( ({ to, name, title, exact, Icon }, index) => (
                        <NavItem key={`payment-${index}`} className={bem.e('nav-item')}>
                            <BSNavLink
                                id={`navItem-${name}-${index}`}
                                className=""
                                tag={NavLink}
                                to={to}
                                exact={exact}
                            >
                                <Icon className={bem.e('nav-item-icon')} />
                                <span className="">{title}</span>
                            </BSNavLink>
                        </NavItem>
                    ))
                }
                {
                    CustomerNav.recharge.map( ({ to, name, title, exact, Icon }, index) => (
                        <NavItem key={`recharge-${index}`} className={bem.e('nav-item')}>
                            <BSNavLink
                                id={`navItem-${name}-${index}`}
                                className=""
                                tag={NavLink}
                                to={to}
                                exact={exact}
                            >
                                <Icon className={bem.e('nav-item-icon')} />
                                <span className="">{title}</span>
                            </BSNavLink>
                        </NavItem>
                    ))
                }
            </>
        )
        return (
            menuPayment
        );
    }

    loadNotification = () => {
        return (
            CustomerNav.notification.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={`notification-${index}`} className={bem.e('nav-item')}>
                    <BSNavLink
                      id={`navItem-${name}-${index}`}
                      tag={NavLink}
                      to={to}
                      exact={exact}
                    >
                        <Icon className={bem.e('nav-item-icon')} />
                        <span className="nav-title">Thông báo</span>
                    </BSNavLink>
                </NavItem>
            ))
        )
    }

    loadTicket = () => {
        return (
            CustomerNav.ticket.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={`ticket-${index}`} className={bem.e('nav-item')}>
                    <BSNavLink
                      id={`navItem-${name}-${index}`}
                      tag={NavLink}
                      to={to}
                      exact={exact}
                    >
                        <Icon className={bem.e('nav-item-icon')} />
                        <span className="nav-title">Hổ trợ</span>
                    </BSNavLink>
                </NavItem>
            ))
        )
    }

    loadLogActivities = () => {
        return (
            CustomerNav.log.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={`log-${index}`} className={bem.e('nav-item')}>
                    <BSNavLink
                      id={`navItem-${name}-${index}`}
                      tag={NavLink}
                      to={to}
                      exact={exact}
                    >
                        <FaHistory className={bem.e('nav-item-icon')} />
                        <span className="nav-title">Lịch sử hoạt động</span>
                    </BSNavLink>
                </NavItem>
            ))
        )
    }

    loadIndex = () => {
        return (
            CustomerNav.dashboar.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={`dashboar_${index}`} className={bem.e('nav-item')}>
                    <BSNavLink
                        id={`navItem-${name}-${index}`}
                        tag={NavLink}
                        to={to}
                        exact={exact}
                    >
                        <MdDashboard className={bem.e('nav-item-icon')} />
                        <span className="nav-title">DashBoard</span>
                    </BSNavLink>
                </NavItem>
            ))
        )
    }

    render() {
        return (
            <aside 
                // className="cr-sidebar cr-sidebar--open"
                className={bem.b()} data-image={sidebarBgImage}
            >
                <div 
                    // className="cr-sidebar__background" 
                    className={bem.e('background')} style={sidebarBackground}
                />
                <div 
                    // className="cr-sidebar__content"
                    className={bem.e('content')}
                >
                    <Navbar className="border-bottom-white">
                        <Link to="/" className="brand-link">
                            <img src={ this.props.config.website_logo_w }
                                width="35"
                                height="35"
                                className="brand-image img-circle"
                                alt="logo"
                            />
                            <span className="text-white brand-text font-weight-light">
                                { this.props.config.website_name }
                            </span>
                        </Link>
                    </Navbar>
                    <Nav vertical>

                        {/* DashBoard index */}
                        { this.loadIndex() }

                        {/* Product */}
                        { this.loadProductMenu() }
                        {/* Service */}
                        {
                            this.loadServiceMenu()
                        }
                        {/* Order */}
                        {
                            this.loadOrderMenu()
                        }
                        {/* Payment */}
                        {
                            this.loadOrderPayment()
                        }
                        {/* Thông báo */}
                        {
                            this.loadNotification()
                        }
                        {/* Hổ trợ */}
                        {
                            this.loadTicket()
                        }
                        {/* Log */}
                        {
                            this.loadLogActivities()
                        }
                    </Nav>
                </div>
            </aside>
        );
    }
}

const mapStateToProps = (state) => {
    // console.log(state.system);
    return {
        user: state.user.user,
        sessionRole: state.user.sessionRole,
        vps: state.system.vps,
        vps_us: state.system.vps_us,
        cloudServer: state.system.cloudServer,
        hosting: state.system.hosting,
        proxy: state.system.proxy,
        menuProduct: state.system.menuProduct,
        config: state.configSystem.config,
        menuCustomer: state.system.menuCustomer,
    }
}
export default connect(mapStateToProps)(CustomerSiderBar);